import { Capacitor } from '@capacitor/core';
import { App as CapacitorApp } from '@capacitor/app';

/** true when running inside a Capacitor native shell (Android / iOS) */
export const isNativePlatform = Capacitor.isNativePlatform();

/** Current native platform or 'web' */
export const nativePlatform = Capacitor.getPlatform(); // 'android' | 'ios' | 'web'

/**
 * Register the hardware back-button listener on Android.
 * Falls back to browser history.back() and only exits the app
 * when there is no more history to pop.
 */
export const registerNativeBackButton = () => {
  if (!isNativePlatform) return;

  CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack) {
      window.history.back();
    } else {
      void CapacitorApp.exitApp();
    }
  });
};

/**
 * Call once at app startup to initialise all native-specific behaviour.
 */
export const initNativeApp = () => {
  if (!isNativePlatform) return;

  registerNativeBackButton();

  // Hide splash screen after React mounts (handled by Capacitor plugin config)
  // Additional native init can be added here (StatusBar, Keyboard, etc.)
};
